// Config object to be passed to Msal on creation
import {environment} from '@/config/environment';
import router from '../../router/router';

const getRedirectOrigin = () => {
    // Use dev url for local development (*.local domains)
    if (window.location.hostname.endsWith('.local') && environment.VITE_DEV_BASE_URL) {
        return environment.VITE_DEV_BASE_URL;
    }

    return window.location.origin.replace(new RegExp(/(https:\/\/)([\w-]+)(\..+)/i), '$1app$3');
};

/**
 * @returns {{scope: string, response_type: string, redirect_uri: string, client_id: any}}
 */
export const googleConfig = () => ({
    client_id: environment.VITE_OAUTH_GOOGLE_ID,
    redirect_uri: getRedirectOrigin() + router.resolve({name: 'GoogleCallback'}).href,
    response_type: 'code',
    scope: 'email profile openid',
    access_type: 'offline',
    prompt: 'consent',
});
